import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import SEO from 'components/shared/SEO';
import ButtonPrimary from 'components/shared/ButtonPrimary';
import ButtonText from 'components/shared/ButtonText';
import Row from 'components/shared/Row';
import Text from 'components/shared/Text';
import Heading from 'components/shared/Heading';
import Spinner from 'components/shared/Spinner';
import { recoverEmail } from 'reduxConfig/auth.creators';
import styles from './styles.module.scss';

const microapps = window.MICROFRONTENDS_CONFIG;
/**
 * This is the page users see when being redirected from their 'email changed' recovery email link back to nbx.com
 */
function RecoverEmail({ user, dispatch, loading, error, actionCode, isMobile }) {
  const { t } = useTranslation();
  const [initial, setInitial] = useState(true);

  useEffect(() => {
    dispatch(recoverEmail(actionCode));
    setInitial(false);
  }, [actionCode, dispatch]);

  let title = t('auth_action_email_success');
  let blurb = (
    <Trans i18nKey="auth_action_email_success_reset">
      <ButtonText underlined muted to={microapps.routes.resetPassword.path} />
    </Trans>
  );

  if (loading || initial) {
    title = t('auth_action_email_loading');
    blurb = null;
  }

  if (error) {
    title = t('auth_action_email_error');
    blurb = t(error);
  }

  const buttonLink = user ? microapps.routes.dashboards.path : microapps.routes.login.path;
  const buttonLabel = user ? t('auth_action_continue_nbx') : t('auth_action_continue');

  return (
    <>
      <SEO title={t('auth_action_email_meta_title')} />
      <Heading tag="h1">{title}</Heading>

      {blurb && (
        <Text tag="p" muted styles={[styles.belowHeaderText]}>
          {blurb}
        </Text>
      )}

      {loading && (
        <div className={[styles.spinnerContainer]}>
          <Spinner />
        </div>
      )}

      {!loading && (
        <Row styles={[styles.paddedRow]}>
          <ButtonPrimary to={buttonLink} fullWidth={isMobile}>
            {buttonLabel}
          </ButtonPrimary>
        </Row>
      )}
    </>
  );
}

RecoverEmail.propTypes = {
  actionCode: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object,
  error: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired
};

RecoverEmail.defaultProps = {
  actionCode: null,
  user: null,
  error: null
};

export default RecoverEmail;
